<vl-form-grid mod-stacked >
    <vl-column>
        <vl-title tag-name="h2">{{ basketTitleText }}</vl-title>
    </vl-column>
    <template v-if="basketItems && basketItems.length > 0">
        <vl-column  v-for="(item, index) in basketItems" >
            <div :class="{'product-line__totals': true, 'product-line__top-corner': index === 0 }">
                <div class="product-line__totals__label">{{ item.productDescription }}</div>
                <div class="product-line__totals__total">
                    {{ formatCurrency(item.priceExclVat) }}
                    <vl-link @click.prevent="removeItemFromBasket(item)" mod-icon-only
                             icon="trash" mod-error
                             hidden-text="verwijder uit winkelmandje">
                    </vl-link>
                </div>
            </div>
        </vl-column>
        <vl-column v-for="vatTotal in vatTotals" :key="vatTotal.vatPercentage">
            <div class="product-line__totals">
                <div class="product-line__totals__label">Btw {{ vatTotal.vatPercentage }}&percnt;</div>
                <div class="product-line__totals__total">{{ formatCurrency(vatTotal.vatAmount) }}</div>
            </div>
        </vl-column>
        <vl-column>
            <div class="product-line__totals product-line__sum product-line__bottom-corner">
                <div class="product-line__totals__label">Totaal</div>
                <div class="product-line__totals__total">{{ formatCurrency(totalAmountInclVat) }}</div>
            </div>
        </vl-column>
    </template>
</vl-form-grid>
